import { GridLegacy, MenuItem } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

function Algemeen() {
  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <FormTextTC name={"zoneName"} tDefault={"Zone name"} tKey={"tafels.form.algemeen.label.zoneName"} />
          <FormTextTC
            name={"zoneDescription"}
            tDefault={"Zone description"}
            tKey={"tafels.form.algemeen.label.zoneDescription"}
          />
          <FormSwitchTC
            name={"disableTables"}
            tDefault={"Disable all tables for this zone"}
            tKey={"zones.form.algemeen.label.disableTables"}
          />
          <FormSelectTC
            tKey={"salesareaPaydirect"}
            tDefault={"PayDirect of Salesarea"}
            name={"vestiging.payDirect"}
            disabled={true}
            options={[
              <MenuItem key={"0"} value={0}>
                <TranslationWrapper tKey={"Disabled"} tDefault={"Disabled"} />
              </MenuItem>,
              <MenuItem key={"1"} value={1}>
                <TranslationWrapper tKey={"Enabled"} tDefault={"Enabled"} />
              </MenuItem>,
            ]}
          />

          <FormSelectTC
            name={"pay_direct"}
            defaultValue={0}
            tKey={"Pay direct"}
            options={[
              <MenuItem key={"DEFAULT"} value={0}>
                <TranslationWrapper tKey={"Default, do not overwrite"} tDefault={"Default, do not overwrite"} />
              </MenuItem>,
              <MenuItem key={"ENABLED"} value={1}>
                <TranslationWrapper tKey={"Enable pay direct"} tDefault={"Enable pay direct"} />
              </MenuItem>,
              <MenuItem key={"DISABLED"} value={-1}>
                <TranslationWrapper tKey={"Disable pay direct"} tDefault={"Disable pay direct"} />
              </MenuItem>,
            ]}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
